var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-block__heading page-block__heading--withbar"},[_c('h3',{staticClass:"page-block__title"},[_vm._v("\n    "+_vm._s(_vm.subHeader)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }